import adapter from './adapter';

export const DB_EXPERT_DOMAIN_ID = 'expert.normacs.ru';

export default Object.assign(Object.create(adapter), {
  /**
   * @returns {Promise<{string, ApiDatabase}>}
   */
  getDatabases() {
    let data = this.getCache('databases');

    if (!data) {
      data = this.getData(`/databases/`);
      this.setCache('databases', data);
    }

    return data;
  }
});
